import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';

import { reportAppError } from '../features/errors/ErrorPopupProvider';

export const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) =>
      reportAppError(error, {
        operation: String(query.queryKey[0] ?? 'query'),
        retry: () => void query.fetch(),
      }),
  }),
  mutationCache: new MutationCache({
    onError: (error, variables, _context, mutation) =>
      reportAppError(error, {
        operation: String(mutation.options.mutationKey?.[0] ?? 'mutation'),
        retry:
          mutation.meta?.errorRetry === true
            ? () => void mutation.execute(variables)
            : undefined,
      }),
  }),
  defaultOptions: {
    queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
  },
});

/** Remove authenticated server data before a dashboard session changes. */
export const clearAuthenticatedQueryCache = (): void => {
  queryClient.clear();
};
